import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'utc',
  pure: false
})
export class UtcDatePipe implements PipeTransform {
  transform(value: Date | string) {
    if (!value) {
      return '';
    }
    let utcDate: Date;
    utcDate = new Date(value.toString());
    let month: number, day: number, year: number;
    month = utcDate.getMonth();
    day = utcDate.getDate();
    year = utcDate.getFullYear();
    const offset = new Date().getTimezoneOffset();
    const rtrnDate = new Date(year, month, day);
    if (offset > 0) {
      rtrnDate.setDate(rtrnDate.getDate() + 1);
    }
    let returnDate = '';

    month = rtrnDate.getMonth() + 1;
    if (month > 9) {
      returnDate = returnDate + month;
    } else {
      returnDate = returnDate + '0' + month;
    }

    returnDate = returnDate + '/';

    day = rtrnDate.getDate();
    if (day > 9) {
      returnDate = returnDate + day;
    } else {
      returnDate = returnDate + '0' + day;
    }

    returnDate = returnDate + '/';

    year = rtrnDate.getFullYear();
    returnDate = returnDate + year;

    return returnDate;
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/pipes/utc.ts